import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetCurrency } from "../SuperSettingsScreen/hook/useCompony";

interface CountryMasterModalContentProps {
  handleSubmit: (formData: { name: string; currency: any }) => void; // Pass data up
  handleClose: () => void;
  selectedRow?: any;
  modalStatus?: string | number;
  name: string;
  selectedCurrency?: string | number;
  setName?: any;
  setSelectedCurrency?: any;
}

const CountryMasterModalContent: React.FC<CountryMasterModalContentProps> = ({
  handleSubmit,
  handleClose,
  selectedRow,
  modalStatus,
  name,
  setName,
  selectedCurrency,
  setSelectedCurrency,
}) => {
  // Local state

  // Currency Dropdown Data.
  const {
    isLoading: curreneyIsloading,
    isSuccess: CurrencyIssuccess,
    data: currecncydata,
  } = useGetCurrency({ enable: true });

  useEffect(() => {
    if (modalStatus === "Edit" && selectedRow) {
      setName(selectedRow?.Scountry);
      setSelectedCurrency(selectedRow?.Currencies?.CurrencyId);
    }
  }, [selectedRow]);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Send form data back to parent
    handleSubmit({
      name,
      currency: selectedCurrency,
    });
  };
  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="col-md-12">
          <label style={{ fontWeight: "500" }}>Country Name<span style={{color:'red'}}>*</span></label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Country name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{
              borderRadius: "4px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ReusableDropdown
           asterisk
            options={currecncydata?.formateData || []}
            value={selectedCurrency} // Controlled value
            onChange={(value: any) => setSelectedCurrency(value)}
            // onChange={(value: any) => {
            //   console.log(value);
            // }}
            DropdownHeading="Currency"
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          {modalStatus === "Edit" ? "Update" : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default CountryMasterModalContent;
